import * as React from "react";
import { List } from "../generic/list/List";
export var createHudLayout = function (layoutIds, className) { return function (_a) {
    var children = _a.children;
    return (React.createElement(List, { className: className, items: layoutIds, renderItem: function (id) { return (React.createElement("div", { key: id, className: className + "__" + id }, children(id))); } }));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/hud/createHudLayout.tsx
// module id = 2261
// module chunks = 3